import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import xamatron from "xamatron";
function createEmptyForm() {
    return {
        name: "",
        email: "",
        country: "",
        message: "",
    };
}
var AboutCompanyView = /** @class */ (function (_super) {
    tslib_1.__extends(AboutCompanyView, _super);
    function AboutCompanyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ready = false;
        _this.sending = false;
        _this.form = createEmptyForm();
        return _this;
    }
    AboutCompanyView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("dealers/regions", { params: { locale: this.$i18n.locale } })];
                    case 1:
                        data = (_a.sent()).data;
                        this.dealerRegions = data;
                        this.ready = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    AboutCompanyView.prototype.send = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!(this.form.name && this.form.email && this.form.country && this.form.message)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("contactView.validationError") })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.sending = true;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 6, , 8]);
                        return [4 /*yield*/, axios.post("contact/send", this.form)];
                    case 4:
                        _a.sent();
                        this.sending = false;
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("contactView.sendSuccess") })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        err_1 = _a.sent();
                        this.sending = false;
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("contactView.sendError") })];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 8:
                        this.form = createEmptyForm();
                        return [2 /*return*/];
                }
            });
        });
    };
    AboutCompanyView.prototype.open = function (url) {
        xamatron.openURL(url);
    };
    AboutCompanyView = tslib_1.__decorate([
        Component
    ], AboutCompanyView);
    return AboutCompanyView;
}(Vue));
export default AboutCompanyView;
